import { Box, IconButton, Modal, Typography } from "@mui/material";
import { forwardRef, useImperativeHandle, useState } from "react";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";

const CanteenTeamSizeExceededWarningPopup = forwardRef(({style, closeReq = false }, ref) => {
  const [validationFailed, setValidationFailed] = useState(false);
  const handleClose = () => {
    setValidationFailed(false);
  };
  const validateAIConfig = (teamSize) => {
    return new Promise((resolve, reject) => {
        if(teamSize) {
          if(teamSize > "0") {
            setValidationFailed(false);
            resolve({ ok: true });
            return;
          } else {
            setValidationFailed(true);
            resolve({ ok: false});
            return;
          }
        } else {
          setValidationFailed(true);
          resolve({ ok: false});
          toast.error("Something went wrong!");
          return;
        }
        // GetCanteenTeamSizeUtilizedHelper().then((res) => {
        //     if(res?.data?.statuscode === 200){
        //       const resData = res?.data?.data?.[0]
        //       if(resData?.fn_get_canteen_team_size_utilized > "0") {
        //         setValidationFailed(false);
        //         resolve({ ok: true });
        //         return;
        //       } else {
        //         setValidationFailed(true);
        //         resolve({ ok: false});
        //         return;
        //       }
        //     } else {
        //         setValidationFailed(true);
        //         resolve({ ok: false});
        //         toast.error("Something went wrong!");
        //         return;
        //     }
        // });
    })
  }
  useImperativeHandle(ref, () => ({
    validateAIConfig,
  }));


  return (
    <Modal
      open={validationFailed}
      disablePortal
      hideBackdrop
      disableEscapeKeyDown
      onClose={() => {}}
      sx={{
        position: "absolute",
        inset: style?.inset ? style?.inset : 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(2px)",
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          p: 3,
          borderRadius: 2,
          backgroundColor: "#fff",
          boxShadow: 3,
          textAlign: "center",
          maxWidth: 400,
          mx: "auto",
          position: "relative"
        }}
      >
       {closeReq && <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            "&:hover": { color: "black" },
          }}
        >
          <CloseIcon />
        </IconButton>}
        <Typography variant="h6" color="error" sx={{ mt: 3, mb: 2 }}>
          ⚠️ Canteen Management Team Size Exceeded!
        </Typography>
        <Typography sx={{ mb: 2 }}>
          
            Please contact meepl admin team for assistance.
        </Typography>
      </Box>
    </Modal>
  );
});

export default CanteenTeamSizeExceededWarningPopup;
